import numeral from 'numeral'

const isFalse = value => {
  if (typeof value === 'boolean' && value === false) return false
  return !value
}
//格式化小数点保留三位
const NumFilter = value => {
  // 截取当前数据到小数点后两位
  let realVal = parseFloat(value).toFixed(3)
  return realVal
}

// 格式化金额 四舍五入并且不要 .00
const formatAmount = amount => {
  if (amount) {
    return numeral(Math.round(amount)).format('0,0')
  }
  return 0
}
// 格式化金额 => 四舍五入并且不要 .00
const formatAmount1 = amount => {
  if (amount) {
    return numeral(Math.round(amount)).format('0,0')
  }
  return 0
}
const setSeperatenum = amount => {
  if (amount) {
    return numeral(amount).format('0,0')
  }
  return 0
}
const resetAmount = amount => {
  if (amount) {
    return numeral(amount).format('0.00')
  }
  return 0
}
const formatAmount2 = amount => {
  if (amount) {
    return numeral(amount).format('0,0.00')
  }
  return 0
}

export default {
  isFalse,
  formatAmount,
  formatAmount1,
  formatAmount2,
  setSeperatenum,
  resetAmount,
  NumFilter,
}
